module.exports = __webpack_public_path__ + "static/media/S1_00021.ce8f42f6.jpg";